import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";

const label = (box) => `${box.name} · ${box.currency || ""}`;

// المناقلة بين الفروع: كل صندوق بعملة فرعه، والفرق يُحسب بسعر الصرف من الإعدادات.
export const TransferPanel = ({ move, setMove, boxes, transfers, plan, onSubmit, onApprove }) => {
  const { t } = useTranslation();
  const set = (key) => (event) => setMove({ ...move, [key]: event.target.value });

  return (
    <>
      <NeuCard className="grid gap-3 p-5 sm:grid-cols-4" data-testid="transfer-form">
        {[
          ["from_cashbox_id", "acct.from", "transfer-from"],
          ["to_cashbox_id", "acct.to", "transfer-to"],
        ].map(([key, text, testId]) => (
          <NeuSelect key={key} data-testid={testId} value={move[key]} onChange={set(key)}>
            <option value="">{t(text)}</option>
            {boxes.map((box) => (
              <option key={box.id} value={box.id}>{label(box)}</option>
            ))}
          </NeuSelect>
        ))}
        <NeuInput data-testid="transfer-amount" type="number" placeholder={t("acct.amount")} value={move.amount} onChange={set("amount")} />
        <NeuButton
          variant="primary"
          data-testid="transfer-save"
          disabled={!move.amount || !move.from_cashbox_id || !move.to_cashbox_id}
          onClick={onSubmit}
        >
          {t("acct.requestTransfer")}
        </NeuButton>

        {plan?.cross_currency ? (
          <div className="grid gap-2 sm:col-span-4 sm:grid-cols-[1fr_auto]" data-testid="transfer-fx">
            <p className="rounded-2xl px-3 py-2 font-mono text-xs font-bold shadow-neu-in" dir="ltr">
              {plan.amount} {plan.from_currency} → {plan.received_amount} {plan.to_currency}
              <span className="ms-3 text-[11px] font-semibold text-muted-foreground">
                @ {Number(plan.exchange_rate).toFixed(6)} · {plan.base_currency} {plan.amount_base}
              </span>
            </p>
            <NeuInput
              type="number"
              className="w-40"
              data-testid="transfer-manual-rate"
              placeholder={t("acct.manualRate")}
              value={move.manual_rate || ""}
              onChange={set("manual_rate")}
            />
          </div>
        ) : null}
      </NeuCard>

      <div className="grid gap-2" data-testid="transfer-list">
        {transfers.map((tr) => (
          <NeuCard key={tr.id} className="flex flex-wrap items-center gap-3 p-3" data-testid={`transfer-row-${tr.id}`}>
            <span className="font-mono text-xs" dir="ltr">{tr.date}</span>
            <span className="font-mono text-sm font-bold" dir="ltr">{tr.amount} {tr.from_currency}</span>
            {tr.cross_currency ? (
              <span className="font-mono text-xs text-primary" dir="ltr">
                → {tr.received_amount} {tr.to_currency} @ {Number(tr.exchange_rate).toFixed(4)}
              </span>
            ) : null}
            <span className="text-xs font-bold">{t(`acct.transferStatus.${tr.status}`)}</span>
            {tr.status === "pending" ? (
              <NeuButton className="ms-auto px-3 py-2 text-xs" data-testid={`transfer-approve-${tr.id}`} onClick={() => onApprove(tr)}>
                {t("acct.approve")}
              </NeuButton>
            ) : (
              <span className="ms-auto font-mono text-[11px] text-primary" dir="ltr">{tr.entry_number}</span>
            )}
          </NeuCard>
        ))}
      </div>
    </>
  );
};
